/* eslint-disable react/prop-types */
import * as React from 'react'
import { cn } from '@/lib/utils'
import * as PopoverPrimitive from '@radix-ui/react-popover'

const Popover = PopoverPrimitive.Root

const PopoverTrigger = PopoverPrimitive.Trigger

const PopoverAnchor = PopoverPrimitive.Anchor

const PopoverContent = React.forwardRef<
    React.ElementRef<typeof PopoverPrimitive.Content>,
    React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = 'center', sideOffset = 4, ...props }, ref) => (
    <PopoverPrimitive.Portal>
        <PopoverPrimitive.Content
            ref={ref}
            align={align}
            sideOffset={sideOffset}
            // pointer-events-auto: a modal Dialog sets `pointer-events: none` on <body>, and this content is
            // portaled there. Dialog and Popover resolve to separate copies of Radix's dismissable-layer,
            // so the dialog's copy never re-enables it and clicks would fall through to the backdrop.
            // Off again while closing, so the exit animation never intercepts a click.
            className={cn(
                'pointer-events-auto z-50 w-72 data-[state=closed]:pointer-events-none rounded-md border bg-popover p-4 text-popover-foreground shadow-gt-m outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-1 data-[side=left]:slide-in-from-right-1 data-[side=right]:slide-in-from-left-1 data-[side=top]:slide-in-from-bottom-1 duration-base ease-out data-[state=closed]:duration-fast data-[state=closed]:ease-in origin-[--radix-popover-content-transform-origin]',
                className
            )}
            {...props}
        />
    </PopoverPrimitive.Portal>
))
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor }
